import styled from '@emotion/styled';
import { ClassAttributes, createElement } from 'react';

interface Props {
  className?: string;
}

const Logo = ({ className }: ClassAttributes<SVGElement> & Props) => (
  <Root viewBox="0 0 1528 390" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path
      d="M350.975,215.7744 L368.288,215.7744 L368.288,247.5074 L397.579,215.7744 L418.995,215.7744 L388.149,249.9414 C390.812,253.6264 395.729,260.4994 402.907,270.5624 C410.081,280.6224 415.443,288.1234 418.995,293.0614 L398.803,293.0614 L376.056,262.5444 L368.288,271.1684 L368.288,293.0614 L350.975,293.0614 L350.975,215.7744 Z"
      id="Fill-3"
      fill="#4C566C"
    />
    <path
      d="M461.6024,238.7739 L451.8334,261.2179 L471.2564,261.2179 L461.6024,238.7739 Z M485.0124,293.0609 L477.8054,276.3649 L445.2894,276.3649 L438.0794,293.0609 L419.6604,293.0609 L453.1694,215.7739 L469.9204,215.7739 L503.4334,293.0609 L485.0124,293.0609 Z"
      id="Fill-5"
      fill="#4C566C"
    />
    <polygon id="Fill-7" fill="#4C566C" points="512.422 293.061 529.73 293.061 529.73 215.774 512.422 215.774" />
    <polygon
      id="Fill-9"
      fill="#4C566C"
      points="544.3713 293.061 544.3713 281.231 584.9863 230.704 545.7073 230.704 545.7073 215.774 608.6203 215.774 608.6203 227.715 568.1203 278.024 609.2883 278.024 609.2883 293.061"
    />
    <polygon
      id="Fill-10"
      fill="#4C566C"
      points="680.3003 215.7744 680.3003 231.1444 641.6873 231.1444 641.6873 247.0644 676.4163 247.0644 676.4163 261.7714 641.6873 261.7714 641.6873 277.8044 681.5183 277.8044 681.5183 293.0614 624.3763 293.0614 624.3763 215.7744"
    />
    <polygon
      id="Fill-11"
      fill="#4C566C"
      points="751.2018 215.7744 768.5098 215.7744 768.5098 293.0614 751.2018 293.0614 714.2518 244.6314 714.2518 293.0614 696.9378 293.0614 696.9378 215.7744 713.1458 215.7744 751.2018 265.5304"
    />
    <path
      d="M862.3218,254.4189 C864.9468,251.6529 866.2628,247.6009 866.2628,242.2559 C866.2628,236.9129 864.5978,233.1339 861.2718,230.9239 C857.9408,228.7109 852.7278,227.6049 845.6258,227.6049 L832.3118,227.6049 L832.3118,258.5649 L847.5098,258.5649 C854.7638,258.5649 859.6978,257.1829 862.3218,254.4189 M871.5888,222.5209 C876.9888,227.0159 879.6898,233.9459 879.6898,243.3049 C879.6898,252.6689 876.9338,259.5219 871.4228,263.8709 C865.9128,268.2219 857.4598,270.3949 846.0688,270.3949 L832.3118,270.3949 L832.3118,293.0609 L819.2118,293.0609 L819.2118,215.7739 L845.8478,215.7739 C857.6068,215.7739 866.1888,218.0229 871.5888,222.5209"
      id="Fill-12"
      fill="#4C566C"
    />
    <polygon
      id="Fill-13"
      fill="#4C566C"
      points="895.1096 293.061 895.1096 215.774 908.2046 215.774 908.2046 280.677 943.6006 280.677 943.6006 293.061"
    />
    <path
      d="M1002.4084,263.4304 L988.3184,231.5874 L974.2254,263.4304 L1002.4084,263.4304 Z M968.8994,275.4814 L961.1294,293.0614 L947.1504,293.0614 L981.3244,215.7744 L995.3064,215.7744 L1029.4814,293.0614 L1015.5014,293.0614 L1007.7364,275.4814 L968.8994,275.4814 Z"
      id="Fill-14"
      fill="#4C566C"
    />
    <polygon
      id="Fill-15"
      fill="#4C566C"
      points="1063.4351 227.7151 1063.4351 293.0611 1050.3421 293.0611 1050.3421 227.7151 1026.8191 227.7151 1026.8191 215.7741 1086.9631 215.7741 1086.9631 227.7151"
    />
    <polygon
      id="Fill-16"
      fill="#4C566C"
      points="1114.2546 227.9377 1114.2546 249.1667 1148.6526 249.1667 1148.6526 261.2177 1114.2546 261.2177 1114.2546 293.0607 1101.1596 293.0607 1101.1596 215.7747 1152.8656 215.7747 1152.7546 227.9377"
    />
    <path
      d="M1223.4927,234.0181 C1218.2007,228.5651 1211.7097,225.8381 1204.0167,225.8381 C1196.3217,225.8381 1189.8327,228.5651 1184.5427,234.0181 C1179.2507,239.4761 1176.6097,246.0901 1176.6097,253.8661 C1176.6097,261.6441 1179.2507,268.2581 1184.5427,273.7141 C1189.8327,279.1691 1196.3217,281.8941 1204.0167,281.8941 C1211.7097,281.8941 1218.2007,279.1691 1223.4927,273.7141 C1228.7797,268.2581 1231.4207,261.6441 1231.4207,253.8661 C1231.4207,246.0901 1228.7797,239.4761 1223.4927,234.0181 M1233.0917,282.3921 C1225.2467,290.0221 1215.5567,293.8351 1204.0167,293.8351 C1192.4787,293.8351 1182.7857,290.0221 1174.9467,282.3921 C1167.1077,274.7621 1163.1877,265.2551 1163.1877,253.8661 C1163.1877,242.4761 1167.1077,232.9691 1174.9467,225.3391 C1182.7857,217.7101 1192.4787,213.8941 1204.0167,213.8941 C1215.5567,213.8941 1225.2467,217.7101 1233.0917,225.3391 C1240.9307,232.9691 1244.8487,242.4761 1244.8487,253.8661 C1244.8487,265.2551 1240.9307,274.7621 1233.0917,282.3921"
      id="Fill-17"
      fill="#4C566C"
    />
    <path
      d="M1305.877,251.8208 C1308.54,249.5358 1309.876,245.8698 1309.876,240.8188 C1309.876,235.7708 1308.504,232.3058 1305.767,230.4258 C1303.029,228.5458 1298.143,227.6048 1291.121,227.6048 L1274.476,227.6048 L1274.476,255.2478 L1290.787,255.2478 C1298.184,255.2478 1303.214,254.1048 1305.877,251.8208 M1323.301,240.8718 C1323.301,253.6268 1317.713,261.6608 1306.543,264.9778 L1326.851,293.0608 L1310.208,293.0608 L1291.671,267.0778 L1274.476,267.0778 L1274.476,293.0608 L1261.385,293.0608 L1261.385,215.7748 L1290.232,215.7748 C1302.065,215.7748 1310.539,217.7668 1315.644,221.7478 C1320.746,225.7268 1323.301,232.1018 1323.301,240.8718"
      id="Fill-18"
      fill="#4C566C"
    />
    <polygon
      id="Fill-19"
      fill="#4C566C"
      points="1355.2571 293.061 1342.1621 293.061 1342.1621 215.774 1362.5801 215.774 1385.9881 264.314 1409.4031 215.774 1429.7031 215.774 1429.7031 293.061 1416.6151 293.061 1416.6151 232.691 1389.5421 286.317 1382.2151 286.317 1355.2571 232.691"
    />
    <polygon id="Fill-20" fill="#4C566C" points="98.1 293.061 292.768 293.061 292.768 254.266 98.1 254.266" />
    <polygon
      id="Fill-21"
      fill="#2DD28D"
      points="234.3658 99.0847 234.3658 118.4817 260.0518 118.4817 171.3588 206.8597 98.0998 133.8637 98.0998 161.2957 171.3838 234.3177 273.3008 132.7167 273.3008 157.2777 292.7678 157.2777 292.7678 99.0847"
    />
  </Root>
);

const Root = styled('svg')({ width: 200, height: 'auto' });

export default Logo;
